// extracted by mini-css-extract-plugin
module.exports = {"item":"dropHover_item__2aJPB","leftItem":"dropHover_leftItem__R27YH","rightItem":"dropHover_rightItem__1QoVO","both":"dropHover_both__3kA2N"};